<ng-container *ngTemplateOutlet="hasRuntime ? launch : runtime"></ng-container>

<ng-template #launch>
    <app-start-scope (hasDownloadChange)="hasDownload=$event" (hasRuntimeChange)="hasRuntime=$event"> </app-start-scope>
</ng-template>

<ng-template #runtime>
    <ng-container *ngTemplateOutlet="!hasDownload ? downloadList : startApp"></ng-container>

    <ng-template #downloadList>
        <app-runtime-list (hasDownloadChange)="hasDownload=$event" (hasRuntimeChange)="hasRuntime=$event">
        </app-runtime-list>
    </ng-template>

    <ng-template #startApp>
        <app-launch-scope (doLaunchScope)="launchScope()"></app-launch-scope>
    </ng-template>
</ng-template>
